export const returnNullFooterPathNames = [
  "/p/AetnaDiscount",
  "/p/anthem",
  "/p/amazon",
  "/asuris",
  "/p/bravenhealth",
  "/p/kaiser",
  "/regence",
  "/p/bcbsri",
]
